import React from "react";
import { Route, Switch } from "react-router-dom";
import { templateRoutes } from "./routes";

const TemplateRouter = () => {
  return (
    <Switch>
      {templateRoutes.map((route, index) => (
        <Route key={index} exact={route.exact} path={route.path}>
          <route.main />
        </Route>
      ))}
    </Switch>
  );
};

export default TemplateRouter;
